import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../Confg/UserContext';
import { getAdminActingStore, clearAdminActingStore, ADMIN_STORE_EVENT } from '../utils/adminSession';

/**
 * Faixa fixa exibida enquanto um admin da Auuii opera a loja de outra pessoa.
 *
 * Existe por um motivo prático: sem ela, a tela de admin dentro de uma loja é
 * idêntica à do lojista dono. É como se editam preços, cardápio e financeiro da
 * loja errada sem perceber.
 */
const AdminStoreBanner = () => {
    const { isAdmin } = useUser();
    const navigate = useNavigate();
    const [acting, setActing] = useState(getAdminActingStore);

    useEffect(() => {
        const sync = () => setActing(getAdminActingStore());
        window.addEventListener(ADMIN_STORE_EVENT, sync);
        window.addEventListener('storage', sync); // outras abas
        return () => {
            window.removeEventListener(ADMIN_STORE_EVENT, sync);
            window.removeEventListener('storage', sync);
        };
    }, []);

    const sair = useCallback(() => {
        clearAdminActingStore();
        navigate('/admin/lojas');
    }, [navigate]);

    // A checagem de isAdmin importa: se a claim for revogada, a faixa some
    // sozinha em vez de anunciar um poder que a conta já não tem.
    if (!isAdmin || !acting?.uid) return null;

    return (
        <div
            role="status"
            style={{
                position: 'sticky', top: 0, zIndex: 10500,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                gap: 'var(--space-3)', flexWrap: 'wrap',
                padding: 'var(--space-2) var(--space-4)',
                background: 'var(--paper-raised)', color: 'var(--ink)',
                borderBottom: '1px solid var(--rule)',
                font: '400 13px/18px var(--font-sans)',
            }}
        >
            <span>
                Modo admin: você está operando <strong style={{ fontWeight: 600 }}>{acting.name}</strong>
            </span>
            <button type="button" onClick={sair} className="ap-btn ap-btn-quiet ap-btn-sm">
                Sair da loja
            </button>
        </div>
    );
};

export default AdminStoreBanner;
